module.exports = __webpack_public_path__ + "static/common-logo-10f261293a72c6b7459382c50e65144b.png";